import { getContext, setContext } from "svelte"
import { writable } from "svelte/store"

/**
 * @typedef {{
 *   projectId: string,
 *   planId: string,
 * }} AutoAssemblyProjectContextValueType
 */

/**
 * @type {AutoAssemblyProjectContextValueType}
 */
const defaultAutoAssemblyProjectContextValue = {
  projectId: "",
  planId: "",
}

const createAutoAssemblyProjectContextValueStore = (initialValues) => {
  return writable(initialValues ?? defaultAutoAssemblyProjectContextValue)
}

const autoMpsProjectContextSymbol = Symbol("autoMpsProject")

export function getAutoAssemblyProjectContext() {
  return getContext(autoMpsProjectContextSymbol)
}

/**
 *
 * @param {AutoAssemblyProjectContextValueType} [autoMpsProjectContextValue]
 */
export function setAutoAssemblyProjectContext(autoMpsProjectContextValue) {
  const store = createAutoAssemblyProjectContextValueStore(autoMpsProjectContextValue)
  setContext(autoMpsProjectContextSymbol, store)
  return store
}
